<template>
  <button
    title="Change transcription language"
    v-tippy="{ placement: 'top' }"
    @click="showModal"
  >
    <font-awesome-icon :icon="faGlobeEurope" />
  </button>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faGlobeEurope } from "@fortawesome/pro-light-svg-icons/faGlobeEurope";
import ChangeTranscriptionLanguageModal from "./ChangeTranscriptionLanguageModal";
import { create } from "vue-modal-dialogs";

const showModal = create({
  component: ChangeTranscriptionLanguageModal,
  wrapper: "activity-summary",
});

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      faGlobeEurope,
    };
  },
  methods: {
    showModal() {
      showModal();
    },
  },
};
</script>



// WEBPACK FOOTER //
// ChangeTranscriptionLanguageButton.vue?2ee0ebf8